import React, { useState } from 'react';

import * as S from './MultiSelectList.styles';

export interface MultiSelectListProps {
  options: string[];
  selected: string[];
  enabled?: string[];
  defaultSelection: string;
  onSelected: (item) => void;
}

const defaultProps: Partial<MultiSelectListProps> = {};

const MultiSelectList: React.FunctionComponent<MultiSelectListProps> = ({
  options,
  enabled,
  defaultSelection,
  onSelected,
  selected,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const select = item => () => {
    onSelected(item);
  };

  return (
    <>
      {isOpen && <S.BackgroundOverlay onClick={() => setIsOpen(false)} />}
      <S.MultiSelectListWrapper>
        <S.SelectButton
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          {defaultSelection}
          <S.Arrow isOpen={isOpen}>
            <svg
              width="9"
              height="6"
              viewBox="0 0 12 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12 0L0 0L6 6L12 0Z" fill="#2D2D2D" />
            </svg>
          </S.Arrow>
        </S.SelectButton>
        <S.SelectionList isOpen={isOpen}>
          <S.List>
            {options.map(option => {
              const isEnabled = enabled ? enabled.includes(option) : true;
              return (
                <S.Item
                  key={option}
                  isEnabled={isEnabled}
                  onClick={isEnabled ? select(option) : undefined}
                >
                  <S.Checkbox isSelected={selected.includes(option)}>
                    {selected.includes(option) && (
                      <svg
                        width="12"
                        height="9"
                        viewBox="0 0 12 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.5 4L4.5 7L10.5 1"
                          stroke="white"
                          strokeWidth="2"
                        />
                      </svg>
                    )}
                  </S.Checkbox>
                  <S.Name>{option}</S.Name>
                </S.Item>
              );
            })}
          </S.List>
        </S.SelectionList>
      </S.MultiSelectListWrapper>
    </>
  );
};

MultiSelectList.defaultProps = defaultProps;

export default MultiSelectList;
